import {
  Component,
  Event,
  EventEmitter,
  Fragment,
  h,
  Prop,
} from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { getSideDrawerItems } from "@phn/services/menu-items-service";
import { navStateStore } from "../../../../shared/state/nav-state-store";
import { goTo } from "../../../../shared/services/routing-manager";
import { createRoutePath } from "../../../../shared/entities/routing-key";
import { isModelName, isString } from "../../../../shared/utility/helper";

@Component({
  tag: "phn-nd-side-drawer",
  styleUrl: "side-drawer.scss",
  scoped: true,
})
export class SideDrawer {
  @Prop() activeRoutingKey!: string;

  @Prop() locale!: string;

  @Event() bodyTypeChange!: EventEmitter<void>;

  render(): HTMLPhnNdSideDrawerElement {
    const { loggedInState, unreadMessagesCount, userConsent } =
      navStateStore.state;

    // in some unfortunate cases, the userConsent is a boolean due to an outdated state file from the navigation package
    // we assume that an update of the navigation package will fix this issue but need to keep this workaround
    const consentStatus =
      typeof userConsent === "boolean"
        ? userConsent
        : !!userConsent?.googleMaps;

    const sideDrawerItems = getSideDrawerItems(
      navContentStore.state,
      this.locale,
      loggedInState,
      unreadMessagesCount,
      this.activeRoutingKey,
      consentStatus,
    );

    return (
      <div>
        {sideDrawerItems.map(({ routingKeys, ...sideDrawerItem }) => {
          const isActive = routingKeys.includes(this.activeRoutingKey);

          return (
            <Fragment>
              <phn-nd-side-drawer-item
                key={sideDrawerItem.elementId}
                onClick={() => {
                  if (!isString(sideDrawerItem.link) && !isActive) {
                    if (isModelName(sideDrawerItem.text)) {
                      this.bodyTypeChange.emit();
                    }
                    goTo(
                      ...createRoutePath(routingKeys[routingKeys.length - 1]),
                    );
                  }
                }}
                isActive={isActive}
                class={isModelName(sideDrawerItem.text) ? "models" : ""}
                {...sideDrawerItem}
              />
              {isActive ? <div class={`item-highlight`} /> : null}
            </Fragment>
          );
        })}
      </div>
    );
  }
}
